document.addEventListener('DOMContentLoaded', () => {
  // Scope tab and pagination logic to each container
  document.querySelectorAll('.product-tabs-container').forEach(container => {
    
    // Tab button logic
    container.querySelectorAll('.tab-button').forEach(button => {
      button.addEventListener('click', () => {
        const tab = button.dataset.tab;

        // Hide all tab panels within the current container
        container.querySelectorAll('.tab-panel').forEach(panel => {
          panel.style.display = 'none';
        });

        // Remove active class from all buttons in this container
        container.querySelectorAll('.tab-button').forEach(btn => {
          btn.classList.remove('active');
        });

        // Show the selected tab panel
        const activePanel = container.querySelector(`#${tab}`);
        if (activePanel) activePanel.style.display = 'block';

        // Add active class to the clicked button
        button.classList.add('active');

        // Reinitialize Shopify product forms for Quick Add
        if (typeof Shopify !== 'undefined' && Shopify.ProductForm) {
          Shopify.ProductForm.init();
        }
      });
    });

    // Pagination button logic
    container.querySelectorAll('.pagination-button').forEach(button => {
      button.addEventListener('click', () => {
        const paginationContainer = button.closest('.pagination');
        const tab = paginationContainer.dataset.tab;

        // Retrieve and update the current page
        const currentPage = parseInt(paginationContainer.dataset.page || 1, 10);
        const nextPage = button.dataset.page === 'next' ? currentPage + 1 : Math.max(currentPage - 1, 1);
        paginationContainer.dataset.page = nextPage;

        // Simulate paginated content (server-side data adjustment needed here)
        const panel = container.querySelector(`#${tab}`);
        const items = panel.querySelectorAll('.grid__item');
        items.forEach((item, index) => {
          if (index < (nextPage - 1) * 8 || index >= nextPage * 8) {
            item.style.display = 'none';
          } else {
            item.style.display = 'block';
          }
        });

        // Update pagination info
        const paginationInfo = panel.querySelector('.pagination-info');
        if (paginationInfo) {
          paginationInfo.textContent = `Page ${nextPage}`;
        }
      });
    });

  });
});